import env from '../env'
import µUtils from '../libs/utils'
import http from '@/libs/http'

// import authActions from './____auth.actions'
import projectsActions from './projects.actions'
import locationActions from './location.actions'
import hubsActions from './hubs.actions'
import graphActions from './graph.actions'
import customGraphsAction from './customGraphs.action'
import adminActions from './admin.action'
import inventory from './inventory.actions'

// import actionsIPCalls from './____iPCalls.actions'

import { translations } from '../translations'
// const translations = require("../translations").default
// console.log('translations', translations)
/*
	NOTICE:
	- every action starts with an underscore
*/

const callStateMap = {
	inventory: 'inventoryList',
	inventorymeta: 'inventoryMeta',
}

const actions: any = {
	// ...authActions,
	...projectsActions,
	...locationActions,
	...hubsActions,
	// ...actionsIPCalls,
	...graphActions,
	...customGraphsAction,
	...adminActions,
	...inventory,

	_set({ commit }: any, v: any): void {
		commit('set', v)
	},

	_dset({ commit }: any, v: any): void {
		// console.log('d3data _dset',v);
		// commit("set", ['d3DataExtentXFrom', v[0]])
		// commit("set", ['d3DataExtentXTo', v[1]])
		commit('d3set', v)
	},

	// socket_leTest({ commit }: any, data: any) {
		// console.log('leTest in actions', data)
	// },

	// socket_alert({ commit }: any, data: any) {
	// 	µUtils.µ_error(data)
	// },

	socket_wsCount({ commit }: any, data: any) {
		// console.log("wsCount in actions", data);
		commit('set', ['wsCount', data])
	},

	socket_connect({ commit }: any, data: any) {
		// console.log("socket_connect", data);
	},
	socket_disconnect({ commit }: any, data: any) {
		// console.log("socket_disconnect", data);
	},

	socket_refreshHub({ commit }: any, data: any) {
		// console.log("__hubSerial", data)
		commit('set', ['lastUpdateTriggerHub', ''])
		commit('set', ['lastUpdateTriggerHub', data])
	},

	socket_shootAlert({ dispatch }: any, data: any) {
		// console.log("socket_shootAlert", data)
		dispatch('_shootAlert', data)
	},

	//! yocto get / set
	socket_getYocto({ commit }: any, data: any) {
		console.log('getYocto', data)
		commit('set', ['currentYoctoData', data])
	},

	socket_getYoctoDb({ commit }: any, data: any) {
		console.log('getYocto Db', data)
		console.log(data)
		commit('set', ['tempYoctos', data])
	},

	socket_setYocto({ dispatch }: any, data: any) {
		console.log('setYocto', data)
	},

	_makeErrorMsg({ state }: any, error: any) {
		console.error(error)
		const code = error?.response?.data?.code || ''
		if (code) {
			const codeTranslation = translations?.[state.locale]?.server?.[code] || ''
			if (codeTranslation) return codeTranslation
		}
		const msg =
			error.response?.data?.validation?.body?.message ||
			error?.response?.data?.msg ||
			error?.response?.data?.message ||
			// error?.response?.data ||
			error.message
		// console.log(msg)
		return msg
	},

	async _initAdmin({ state, commit, dispatch }: any, data: string[]) {
		console.time('_initAdmin')
		const isAdmin = ['admin', 'developer'].includes(state.user?.role)
		// const allData = ['projects', 'locations', 'hubs', 'allStates', 'comapps', 'version', 'modules', 'customGraphs', 'alerts', 'sundata', 'inventory']
		const allData = [
			'projects',
			'locations',
			'hubs',
			'allStates',
			'comapps',
			'version',
			'modules',
			// 'customGraphs',
			'alerts',
			'sundata',
		]
		if (!data) data = allData

		const allCalls = [
			data.includes('sundata') ? dispatch('_fetchSunData') : null,
			data.includes('allStates') ? dispatch('_allStates') : null,
			data.includes('projects') ? dispatch('_listProjects') : null,
			data.includes('locations') ? dispatch('_listLocations') : null,
			data.includes('hubs') ? dispatch('_listAllHubs') : null,
			data.includes('modules') ? dispatch('_listAllModules') : null,
			// data.includes('customGraphs') ? dispatch('_listCustomGraphs') : null,
			data.includes('version') ? dispatch('_getVersion') : null,
			data.includes('inventory') ? dispatch('_listAllInventory') : null,
		]
		const allVals = await Promise.all(allCalls)

		if (data.includes('sundata')) dispatch('_set', ['sunData', allVals[0]])
		if (data.includes('allStates')) dispatch('_set', ['allStates', allVals[1]])
		if (data.includes('projects')) dispatch('_set', ['projects', allVals[2]])
		if (data.includes('locations')) dispatch('_set', ['locations', allVals[3]])
		if (data.includes('hubs')) dispatch('_set', ['hubs', allVals[4]])
		if (data.includes('modules')) dispatch('_set', ['modules', allVals[5]])
		// if (data.includes('customGraphs')) dispatch('_set', ['customGraphs', allVals[6]])
		if (data.includes('version')) dispatch('_set', ['version', allVals[7]])
		if (data.includes('inventory')) dispatch('_set', ['inventoryList', allVals[8]])

		// console.timeEnd('_initAdmin')

		if (isAdmin && data.includes('alerts')) {
			if (data.includes('comapps')) dispatch('_set', ['comapps', await dispatch('_listComapps')])
			const resp = await dispatch('_getAlerts')
			dispatch('_set', ['alerts', resp.alerts || {}])
			dispatch('_set', ['warns', resp.warns || {}])
		}
	},

	async _listAllBatch({ state, dispatch }: any, keys: string[]) {
		// keys = ['inventory', 'inventorymeta']
		const allCalls: any[] = []
		for (const key of keys) {
			allCalls.push(dispatch('_listAll', key))
		}
		const allVals = await Promise.all(allCalls)
		for (const idx in keys) {
			const key = keys[idx]
			const stateKey = callStateMap[key]
			dispatch('_set', [stateKey, allVals[idx]])
		}
	},

	async _listAll({ dispatch }: any, key: string) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/${key}/list`, config)
			// return resp.data
			const resp = await http.getAuth<any>(`/api/v1/${key}/list`)
			return resp
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			// µUtils.µ_error(msg)
			return []
		}
	},

	//? USER CALLS
	async _fetchUser({ state, commit, dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/user/${state.user?._id || ''}`, config)
			// commit('updateUserData', resp?.data?.user)
			// return resp.data?.user
			const resp = await http.getAuth<any>(`/api/v1/user/${state.user?._id || ''}`)
			commit('updateUserData', resp?.user)
			return resp?.user || {}
		} catch (error: any) {
			// if (error?.response?.data?.relogin) {
			//   commit("set", ['showLoginModal', true])
			//   return {}
			// }

			console.log(error)
			const errMsg = error?.response?.data?.msg || error?.response?.data
			console.log(errMsg)
			throw new Error(errMsg)
		}
	},

	// //? ADMIN CALLS
	// async _fetchUsers({ commit, dispatch }: any) {
	// 	console.log('_fetchUsers')
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + '/api/v1/users/list', config)
	// 		dispatch('_set', ['users', resp.data?.users])
	// 		return resp.data?.users
	// 	} catch (error: any) {
	// 		if (error?.response?.data?.relogin) {
	// 			commit('set', ['showLoginModal', true])
	// 			return {}
	// 		}
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	async _config({ state }: any, data: any) {
		const { _id, email, role, accessToken, accessProjects } = state.user
		return {
			headers: {
				Authorization: accessToken,
				userdata: JSON.stringify({ _id, email, role, accessProjects }),
				locale: state.locale,
			},
		}
	},

	// async _updateUser({ state, dispatch }: any, user: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.post(env.apiUrl + '/api/v1/users/update', { user }, config)
	// 		// console.log(resp.data);
	// 		return resp.data
	// 	} catch (error: any) {
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// async _addUser({ state, dispatch }: any, newUser: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.post(env.apiUrl + '/api/v1/users/add', newUser, config)
	// 		// console.log(resp.data);
	// 		return resp.data
	// 	} catch (error: any) {
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// async _deleteUser({ state, dispatch }: any, userId: string) {
	// 	try {
	// 		console.log('userId', userId)
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.post(env.apiUrl + '/api/v1/users/delete', { userId }, config)
	// 		// console.log(resp.data);
	// 		return resp.data
	// 	} catch (error: any) {
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// async _updateAlertData({ state, dispatch }: any, data: any) {
	// 	try {
	// 		console.log('_updateAlertData', data)
	// 		const config = await dispatch('_config')
	// 		// const resp = await axios.post(env.apiUrl + '/api/v1/users/alertdata/update', data, config)
	// 		const resp = await axios.put(env.apiUrl + '/api/v1/users/alertdata', data, config)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// //? FILES
	// //? FILES

	// //? GET FILES
	// // async _listBBFiles({ state, dispatch }: any, project: any) {
	// // 	try {
	// // 		console.log('_listDoFiles')
	// // 		const config = await dispatch("_config")
	// // 		const resp = await axios.get(env.apiUrl + `/api/v1/storage/${project}`, config)
	// // 		return resp.data
	// // 	} catch (error: any) {
	// // 		console.error(error)
	// // 		const msg = error.response?.data?.msg || error.response?.data || error.message
	//
	// // 		return {}
	// // 	}
	// // },

	// // async _listDoFiles({ state, dispatch }: any, project: any) {
	// async _listDoFiles({ state, dispatch }: any, data: any) {
	// 	console.log('_listDoFiles', data)
	// 	// rootfolder
	// 	const base64path = btoa(data.root || '')
	// 	console.log('base64path', base64path)
	// 	try {
	// 		const config = await dispatch('_config')
	// 		let url = env.apiUrl + `/api/v2/storage/${data.projectId}`
	// 		if (data.root) url = env.apiUrl + `/api/v2/storage/root/${base64path}`
	// 		else if (data.locationId) url = env.apiUrl + `/api/v2/storage/${data.projectId}/${data.locationId}`
	// 		console.log('url', url)
	// 		const resp = await axios.get(url, config)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message

	// 		return {}
	// 	}
	// },

	// // //? GET ONE FILE LINK
	// async _fileUrl({ state, dispatch }: any, fileKey: any) {
	// 	console.log('_fileUrl')
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + `/api/v1/fileurl/${fileKey}`, config)
	// 		console.log(resp.data)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// //? GET ONE FILE LINK
	// async _createZipLink({ state, dispatch }: any, data: any) {
	// 	try {
	// 		console.log(data)
	// 		const config = await dispatch('_config')
	// 		const headers = { ...config.headers, foldername: data.folderName, root: data.root, comapp: data.comapp }
	// 		// const resp = await axios.get(env.apiUrl + `/api/v2/file/${data.project}/${data.fileId}`, { headers })
	// 		const resp = await axios.get(env.apiUrl + `/api/v2/zipfolder/${data.project}`, { headers })
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data || 'failed to download zip')
	// 	}
	// },

	// async _getDoFileLink({ state, dispatch }: any, data: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const headers = { ...config.headers, fileKey: data.fileKey }
	// 		// const resp = await axios.get(env.apiUrl + `/api/v2/file/${data.project}/${data.fileId}`, { headers })
	// 		const resp = await axios.get(env.apiUrl + `/api/v2/file/${data.project}`, { headers })
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// //? DELETE ONE FILE Depriciate
	// async _deleteFile({ state, dispatch }: any, fileId: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.delete(env.apiUrl + `/api/v1/file/delete/${fileId}`, config)
	// 		µUtils.µ_success('file deleted')
	// 		return
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message

	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },
	// //? DELETE ONE FILE DO
	// async _deleteDoFile({ state, dispatch }: any, data: any) {
	// 	try {
	// 		console.log(data)
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.delete(
	// 			env.apiUrl + `/api/v2/delete/${data.project}/${data.fileId}?fileKey=${data.fileKey}`,
	// 			config,
	// 		)
	// 		// console.log(resp.data);
	// 		µUtils.µ_success('file deleted')
	// 		return
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message

	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	// //? HISTORY FOR ONE FILE
	// async _fileHistory({ dispatch }: any, data: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + `/api/v1/filehistory/${data.project}/${data.fileId}`, config)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message

	// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
	// 	}
	// },

	//? COMAPPS
	//? COMAPPS

	async _listComapps({ state, dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v2/comapps`, config)
			// const comapps = resp.data || []
			// return comapps
			const resp = await http.getAuth<any>(`/api/v2/comapps`)
			const comapps = resp || []
			// console.log('comapps', comapps)
			return comapps
		} catch (error: any) {
			console.error(error)
			return {
				storage: [],
				data: [],
			}
		}
	},

	async _updateComapp({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const headers = { ...config.headers, hubids: data.hubids }
			// const resp = await axios.post(env.apiUrl + `/api/v1/comapp/update`, data, { headers })
			// await dispatch('_initAdmin', ['comapps', 'allStates'])
			// return resp.data?.msg || []
			const resp = await http.postAuth<any>(`/api/v1/comapp/update`, data, { headers: { hubids: data.hubids } })
			await dispatch('_initAdmin', ['comapps', 'allStates'])
			return resp?.msg || []
		} catch (error: any) {
			// console.error(error);
			const msg = error.response?.data?.msg || error.response?.data || error.message
			// µUtils.µ_error(msg)
			// return []
			throw new Error(msg)
		}
	},

	//?

	async _allStates({ state, dispatch }: any) {
		try {
			// const resp = await axios.get(env.apiUrl + `/api/v1/general/allstates`, await dispatch('_config'))
			// return resp.data || {}
			const resp = await http.getAuth<any>(`/api/v1/general/allstates`)
			return resp || {}
		} catch (error: any) {
			console.error(error)
			return {
				projects: {},
				locations: {},
				comapps: {},
				hubs: {},
				modules: {},
			}
		}
	},

	async _getVersion({ state, dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/general/version`, config)
			// return resp.data?.version || ''
			const resp = await http.getAuth<any>(`/api/v1/general/version`)
			return resp?.version || ''
		} catch (error: any) {
			console.error(error)
			return {}
		}
	},

	async _getAlerts({ state, dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/general/alerts`, config)
			// return resp.data || {}
			const resp = await http.getAuth<any>(`/api/v1/general/alerts`)
			return resp || {}
		} catch (error: any) {
			console.error(error)
			return {}
		}
	},

	// browser notifications
	async _shootAlert({ state, dispatch }: any, data: any) {
		console.log(data)
		if (!('Notification' in window)) {
			alert('This browser does not support desktop notification')
		} else if (Notification.permission === 'granted') {
			// const notification = new Notification('REVOTEC', {
			// 	body: 'TEST-NOTIFICATON',
			// 	icon: '/img/icons/apple-touch-icon-180x180.png',
			// 	// vibrate: [200, 100, 200],
			// })
			// notification.onclick = (e: any) => {
			// 	e.preventDefault()
			// 	window.open('http://www.mozilla.org', '_blank')
			// }
			// console.log(notification)
		} else if (Notification.permission !== 'denied') {
			Notification.requestPermission().then(function (permission) {
				if (permission === 'granted') {
					const notification = new Notification('Hi there!')
				}
			})
		}
	},
}

export default actions
